export class PushMessageActions {  

  static PUSH_MESSAGE = "@PUSH_MESSAGE";
  static PUSH_MESSAGE_LOADED = "@PUSH_MESSAGE_LOADED";
  static PUSH_MESSAGE_UPLOAD = "@PUSH_MESSAGE_UPLOAD";
}